import React, {Component,useState} from "react";
import Leftmenu from "../element/leftmenu";
import Header from "../element/header";
import PageBreadcrumb from "../element/pagebreadcrumb";
import {DownloadOutlined} from "@ant-design/icons";
import {
    Layout,
    Col,
    Row,
    PageHeader,
    Button,
    Descriptions,
    Typography,
    InputNumber,
    Slider,
    Input,
    Space,
    DatePicker,
    List,
    Card,
    Avatar,
    Popover,
    Select,
    Popconfirm,
    Form,
    Radio,
    Switch,
    Cascader,
    TreeSelect,
    notification,
    message
} from 'antd';
import { EditOutlined, DeleteOutlined, WechatOutlined } from '@ant-design/icons';
import 'moment/locale/zh-cn';
import moment from "moment";
const { Title,Text } = Typography;
const { Content } = Layout;
const { Meta } = Card;
const openNotification = () => {
    notification.open({
        message: '提交成功',
        description:
            '档案修改成功',
        onClick: () => {
            console.log('提交成功');
        },
    });
};
const info = () => {
    message.info('This is a normal message');
};
class PagePurPicked extends Component{

    constructor(props) {
        super(props);
        const params = new URLSearchParams(window.location.search);
        const id = params.get("id");
        const level = params.get("level");
        let source = '';
        switch (level){
            case "1":
                source = "管理员"
                break;
            case "2":
                source = "业务员"
                break;
            case "3":
                source = "司机"
                break;
        }
        this.state = {
            title: "提货单修改",
            source: source,
            county: [],
            id: id,
            level: level,
            list: []
        };
    }

    componentDidMount() {
        fetch("https://pd.pokemonbye.com:8084/api/getsellstock")
            .then(res => res.json())
            .then(
                (result) => {
                    let array = result.data;
                    let option = [];
                    for (let i = 0; i < array.length; i++) {
                        let l = {
                            value: array[i].stockname,
                            label: array[i].stockname
                        }
                        option.push(l)
                        array[i].id = i + 1
                    }
                    this.setState({
                        isLoaded: true,
                        option: option
                    });
                },
                // 注意：需要在此处处理错误
                // 而不是使用 catch() 去捕获错误
                // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
                (error) => {
                    this.setState({
                        isLoaded: true,
                        error
                    });
                }
            )
        fetch("https://pd.pokemonbye.com:8084/api/getsellclientlist")
            .then(res => res.json())
            .then(
                (result) => {
                    let options = [];
                    let array = result.data;
                    for (let i = 0; i < array.length; i++) {
                        let l = {
                            value: array[i].name,
                            label: array[i].name
                        }
                        options.push(l)
                        array[i].id = i + 1
                    }
                    this.setState({
                        isLoaded: true,
                        menulist: array,
                        options: options
                    });
                },
                // 注意：需要在此处处理错误
                // 而不是使用 catch() 去捕获错误
                // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
                (error) => {
                    this.setState({
                        isLoaded: true,
                        error
                    });
                }
            )
        var id = this.state.id
        if(id) {
            fetch("https://pd.pokemonbye.com:8081/api/getweightdaobyid?id=" + id)
                .then(res => res.json())
                .then(
                    (result) => {
                        let array = result.data[0];
                        this.setState({
                            isLoaded: true,
                            list: array
                        });
                        this.formRef.current.setFieldsValue(array)

                    },
                    // 注意：需要在此处处理错误
                    // 而不是使用 catch() 去捕获错误
                    // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
                    (error) => {
                        this.setState({
                            isLoaded: true,
                            error
                        });
                    }
                )
        }
    }
    formRef = React.createRef();
    render() {
        const handleChange = (value) => {
            console.log(value)
            this.setState({
                client: value
            });
        };
        const handleChange2 = (value) => {
            console.log(value)
            this.setState({
                stock: value
            });
        };
        const onFinish = (values) => {
            console.log(this.state.list)
            var list = {};
            list.fahuo = '陕西华山建材营销有限公司';
            list.shouhuo = this.state.client ? this.state.client : this.state.list.buyer;
            list.huoming = this.state.stock ? this.state.stock : this.state.list.stock;
            list.pw = values.weight1 ? values.weight1 : this.state.list.weight1;
            list.mw = values.weight2 ? values.weight2 : this.state.list.weight2;
            list.sw = values.value ? values.value : this.state.list.value;
            list.id = values.id ? values.id : this.state.list.id;

            if(this.state.id){
                function queryParse(query){
                    let queryText = "";
                    for(let key in query){
                        queryText += `${key}=${query[key]}&`;
                    }
                    return queryText.slice(0,-1);
                }

                fetch("https://pd.pokemonbye.com:8081/api/setweightdaobyid",
                    {
                        method:'post',
                        body:queryParse(list),
                        headers:{
                            'Content-Type': "application/x-www-form-urlencoded; charset=UTF-8",
                        }
                    })
                    .then(res => res.json())
                    .then(
                        (result) => {
                            openNotification();

                            setTimeout(window.location.href="/pagepurpickeds",1000);
                        },
                        // 注意：需要在此处处理错误
                        // 而不是使用 catch() 去捕获错误
                        // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
                        (error) => {
                            this.setState({
                                isLoaded: true,
                                error
                            });
                        }
                    )
            }
        };
        return (
            <div>
                <Leftmenu />
                <div className="mainpanel">
                    <Header />
                    <PageBreadcrumb title={this.state.title}/>
                    <Content className="site-layout-background">
                        <div className="site-page-header-ghost-wrapper">
                            <PageHeader
                                ghost={false}
                                onBack={() => window.history.back()}
                                title={this.state.title}
                            >
                                <Form
                                    labelCol={{
                                        span: 4,
                                    }}
                                    wrapperCol={{
                                        span: 10,
                                    }}
                                    layout="horizontal"
                                    size="Large"
                                    onFinish={onFinish}
                                    ref={this.formRef}
                                >
                                    <Form.Item label="提货编号">
                                        <Input disabled={true} bordered={false} placeholder={this.state.list.id}/>
                                    </Form.Item>
                                    <Form.Item label="车牌号">
                                        <Input disabled={true} bordered={false} placeholder={this.state.list.car}/>
                                    </Form.Item>
                                    <Form.Item label="销售单位">
                                        <Input disabled={true} bordered={false} placeholder='陕西华山建材营销有限公司'/>
                                    </Form.Item>
                                    <Form.Item label="提货单位" name="buyer">
                                        <Select
                                            defaultValue={this.state.list.buyer}
                                            style={{
                                                width: 230,
                                            }}
                                            options={this.state.options}
                                            onChange={handleChange}
                                        />
                                    </Form.Item>
                                    <Form.Item label="货品类型" name="stock">
                                        <Select
                                            defaultValue={this.state.list.stock}
                                            style={{
                                                width: 100,
                                            }}
                                            options={this.state.option}
                                            onChange={handleChange2}
                                        />
                                    </Form.Item>
                                    <Form.Item label="皮重（吨）" name="weight1">
                                        <InputNumber placeholder={this.state.list.weight1}/>
                                    </Form.Item>
                                    <Form.Item label="毛重（吨）" name="weight2">
                                        <InputNumber placeholder={this.state.list.weight2}/>
                                    </Form.Item>
                                    <Form.Item label="净重（吨）" name="value">
                                        <InputNumber placeholder={this.state.list.value}/>
                                    </Form.Item>
                                    <Form.Item
                                        wrapperCol={{
                                            offset: 4,
                                            span: 16,
                                        }}
                                    >
                                        <Button type="primary" htmlType="submit">{this.state.id?'提交修改':'新建'}</Button>
                                    </Form.Item>
                                </Form>

                            </PageHeader>
                        </div>
                    </Content>
                </div>
            </div>
        );
    }
}

export default PagePurPicked;


